import { render, staticRenderFns } from "./download-policy.vue?vue&type=template&id=1dc44be0&scoped=true&"
import script from "./download-policy.vue?vue&type=script&lang=js&"
export * from "./download-policy.vue?vue&type=script&lang=js&"
import style0 from "./download-policy.vue?vue&type=style&index=0&id=1dc44be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc44be0",
  null
  
)

export default component.exports